<template>
    <div class="content-wrap">
        <section class="section content-section-01">
            <div class="container">
                <div class="row middle-md">
                    <div class="col-xs-12 col-md-7">
                        <h2 class="margin-bottom">Dein Auto verkaufen - bequem und sicher online</h2>
                        <p>Wenn du dein Auto online verkaufen möchtest und das <strong>schnell, unkompliziert und zum besten Preis</strong>, hast du mit PKW.de die richtige Wahl getroffen. </p>
                    </div>
                    <div class="col-xs-12 col-md-5 align-center">
                        <img src="../assets/verkauf-deinen-gebrauchten.svg" alt="Dein Auto verkaufen - bequem und sicher online" class="car-image" />
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-highlight content-section-02">
            <div class="container">
                <div class="row middle-gi">
                    <div class="col-xs-12 col-md-4 last-xs first-md">
                        <div class="section-image">
                            <img src="../assets/smartphone-image.jpg" alt="Deinen Gebrauchtwagen zu einem Höchstpreis verkaufen - so geht’s" />
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-8">
                        <h3>Deinen Gebrauchtwagen zu einem Höchstpreis verkaufen - so geht’s</h3>
                        <p>Schnell, bequem, sicher und kostenlos das alte Auto zu verkaufen,  ist kein Problem. Wir brauchen nur Marke, Modell, Erstzulassung und ein paar Angaben zu deinem Fahrzeug. Dann ermitteln wir automatisch den aktuellen Marktwert deines Gebrauchtwagens. Die Genauigkeit unserer Marktwerte sind vom TÜV Rheinland untersucht und zertifiziert worden.</p>
                        <h3>Höchstpreis für dein Auto per Auktion</h3>
                        <p>Wenn du dein Auto verkaufen möchtest, kannst du mit wenigen Klicks ein Verkaufs-Exposé erstellen, Fotos von deinem Auto hochladen und dein Auto direkt online verkaufen - per Auktion. Ein Gutachter vereinbart mit dir einen Termin, um sich dein Auto bei dir anzuschauen. Du legst Startpreis, Auktionslänge und optional einen Sofortkauf-Preis fest und die Auktion startet.</p>
                        <p>Zusammen mit unseren Experten legst du selbst den Mindestpreis für dein Fahrzeug fest. In der Auktion erhältst du dann Gebote von unseren geprüften Händlern. Bezahlung, Abholung und Abmeldung übernimmt der Käufer, du musst dich um nichts kümmern. </p>
                        <h3>Autoverkauf bequem vom Sofa aus</h3>
                        <p>Kein lästiges Hin- und Herfahren: Du verkaufst deinen Gebrauchten auf PKW.de komplett vom Sofa aus - schnell, bequem, sicher und kostenlos. Der Gutachter kommt zu dir und auch das Auto holen wir deutschlandweit bei dir ab. Du musst  dich um nichts kümmern und sparst so Zeit und Nerven.  Keine Telefonate, kein Nachverhandeln, kein Stress. So verkaufst du heute dein Auto online. </p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section content-section-03">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-lg-9">
                        <h3 class="small">Ohne Stress und Kompromisse dein Auto verkaufen - vom Sofa aus</h3>
                        <p>Der Verkauf eines gebrauchten Autos war lange Zeit mit großem Aufwand und oft auch Ärger verbunden. So musste ein Inserat mit einer detaillierten Fahrzeugbeschreibung und Bildern geschaltet werden. Im Anschluss galt es, Telefonate mit potenziellen Käufern zu führen. PKW.de macht Schluss damit: <strong>Der Online-Verkauf spart dir Zeit und Nerven!</strong></p>
                    </div>
                </div>
                <div class="row margin-top">
                    <div class="col-xs-12 col-lg-12">
                        <h4>Kostenlos deinen Gebrauchtwagen online verkaufen</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-md-6">
                        <p>Mit dem Online-Verkauf deines Autos entscheidest du dich für eine <strong>reibungslose Abwicklung</strong>, die dazu auch noch <strong>komplett kostenlos</strong> für dich ist. Nach der Schnellbewertung deines Gebrauchten lädst du nur noch einige Fotos des Autos hoch und machst Angaben zum Zustand des Fahrzeugs. Anschließend kommt bei Bedarf ein Gutachter vom TÜV zu dir nach Hause, um deinen Gebrauchtwagen zu begutachten.</p>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <p>Wenn du deinen Gebrauchtwagen schnell, sicher und unkompliziert online verkaufen möchtest, bist du bei PKW.de genau richtig. Mit uns erzielst du dank Auktion und zertifizierter Autohändler ein <strong>Höchstpreis-Angebot</strong> für deinen Gebrauchtwagen. Du musst dich um nichts weiter kümmern, Abholung und Abmeldung übernimmt der Käufer. Der Verkauf ist komplett kostenlos für dich – auch die <strong>Abholung und Abmeldung sind inklusive</strong>. Du musst dich um nichts weiter kümmern!</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "ContentBlock",
    props: ['fee']
}
</script>å

<style lang="scss" scoped>
    @import "~@/assets/vars";
    .section {
        padding:30px 0;

        @include breakpoint(frommediumlarge) {
             padding:54px 0;
        }

        @include breakpoint(fromgiant) {
             padding:100px 0;
        }
        &.section-highlight {
            background:$light-gray;
        }

        .margin-top {
            margin-top:16px;

            @include breakpoint(frommediumlarge) {
                margin-top:39px;
            }
            
            @include breakpoint(fromgiant) {
                margin-top:50px;
            }
        }

        

        &.content-section-01 {
            @include breakpoint(frommediumlarge) {
                padding-top:50px;
            }
            @include breakpoint(fromgiant) {
                padding-top:100px;
            }
            h2 {
                br {
                    @include breakpoint(frommediumlarge) {
                        display:none;
                    }
                    @include breakpoint(fromlarge) {
                        display:block;
                    }
                }
            }
            .car-image {
                max-width:350px;
                margin-top:10px;

                @include breakpoint(frommediumlarge) {
                    margin-top:0;
                    max-width:90%;
                }
            }
        }
        &.content-section-02 {
            .section-image {
                text-align:center;

                @include breakpoint(frommediumlarge) {
                    text-align:left;
                }
                img {
                    margin-top:20px;                    
 
                    @include breakpoint(frommediumlarge) {
                        margin:0;
                        max-width:100%;
                        margin:7px auto;
                    }
                }
            }

            .h4:not(:first-of-type) {
                margin-top:20px;
            }
        }

        &.content-section-03 {
            br {
                display:none;

                @include breakpoint(frommediumlarge) {
                    display: block;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ContentBlock.vue